import http from "@/settings/apiSettings"

class PORTAL_PontajService {
  getPontajLunar(an: number, luna: number): Promise<any> {
    return http.clientPortalHR.get("/portal/pontaj", {
      params: { an, luna },
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getStatusAzi(): Promise<any> {
    return http.clientPortalHR.get("/portal/pontaj/azi", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_PontajService();
